import { render, staticRenderFns } from "./AboutEquipment.vue?vue&type=template&id=b03b804a&scoped=true"
import script from "./AboutEquipment.vue?vue&type=script&lang=js"
export * from "./AboutEquipment.vue?vue&type=script&lang=js"
import style0 from "./AboutEquipment.vue?vue&type=style&index=0&id=b03b804a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03b804a",
  null
  
)

export default component.exports